import { cn } from "../../../../lib/utils";

export function Button({ as, href, className, ...props }) {
	const Component = as === "a" || href ? "a" : "button";
	return (
		<Component
			href={Component === "a" ? href : undefined}
			className={cn(
				"w-full p-0 tracking-[1.8px] flex items-center justify-center rounded-full font-semibold hover:text-white",
				["text-sm leading-10 py-1 h-[48px] max-w-[342px]"],
				[
					"laptop:text-lg laptop:leading-7 laptop:py-3 laptop:h-[64px] laptop:max-w-[503px]",
				],
				className,
			)}
			{...props}
		/>
	);
}
